import { IconPropsType } from '..';

export const SearchIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g id="kb-core-icon">
      <path
        id="Vector"
        d="M10.7523 10.1563H10.1756L9.97109 9.95885C10.7726 9.02471 11.1811 7.81638 11.1107 6.58752C11.0404 5.35865 10.4967 4.20483 9.59378 3.36828C8.69088 2.53173 7.49899 2.0775 6.26834 2.10096C5.03769 2.12443 3.86398 2.62375 2.99362 3.49411C2.12326 4.36447 1.62394 5.53818 1.60048 6.76883C1.57701 7.99948 2.03124 9.19137 2.86779 10.0943C3.70434 10.9972 4.85817 11.5409 6.08703 11.6112C7.31589 11.6816 8.52423 11.2731 9.45836 10.4716L9.65578 10.6761V11.2527L13.3102 14.9001L14.3996 13.8107L10.7523 10.1563ZM6.36777 10.1563C5.71706 10.1566 5.08089 9.96383 4.53972 9.60249C3.99856 9.24115 3.57673 8.72743 3.32758 8.1263C3.07844 7.52518 3.01317 6.86367 3.14005 6.22545C3.26693 5.58723 3.58025 5.00098 4.04037 4.54086C4.50049 4.08074 5.08674 3.76742 5.72496 3.64054C6.36318 3.51366 7.02469 3.57892 7.62582 3.82807C8.22694 4.07721 8.74066 4.49905 9.102 5.04021C9.46334 5.58137 9.65606 6.21755 9.65578 6.86826C9.65634 7.3002 9.57168 7.72802 9.40664 8.12719C9.2416 8.52636 8.99943 8.88905 8.694 9.19448C8.38856 9.49992 8.02587 9.74209 7.6267 9.90713C7.22753 10.0722 6.79971 10.1568 6.36777 10.1563Z"
        fill="#9CA2C2"
      />
    </g>
  </svg>
);
